import Vue from 'vue'
import Vuex from 'vuex'
import environmentModule from './modules/environment'
import settingsModule from './modules/settings'
import palletPatternsModule from './modules/pallet-patterns'
import machineSettingsModule from './modules/machine-settings'
import user from './modules/user'
import patternGenerationModule from './modules/pattern-generation'
import auditTrailModule from './modules/audit-trail'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    environment: environmentModule,
    settings: settingsModule,
    palletpatterns: palletPatternsModule,
    machinesettings: machineSettingsModule,
    user: user,
    patterngeneration: patternGenerationModule,
    auditTrail: auditTrailModule
  }
})
